import { useNavigate } from 'react-router-dom';
import FooterLogo from '../assets/logo/footerLogo.png'
import instagram from '../assets/icon/instagram.png'

const Footer = () => {
    const navigate = useNavigate();

    const goToInstagram = () => {
        window.open('https://www.instagram.com/housefix_official', '_blank', 'noopener,noreferrer')
    }

    const goToContact = () => {
        navigate('/pages/contact')
    }

    const goToAgreement = () => {
        navigate('members/terms')
    }

    const goToPolicy = () => {
        navigate('members/policy')
    }

    return(
        <div style={{padding: "30px 0px 15px", display: "flex", flexDirection: "column", alignItems: "center", }}>
            <div style={{margin: "10px 0px"}}>
                <img onClick={() => {navigate('/')}} src={FooterLogo} style={{width: 369, height: 135, cursor: 'pointer'}} />
            </div>
            <div style={{padding: "8px 0px", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 32}}>
                <div onClick={goToAgreement} style={{padding: "10px 15px", fontSize: 13, fontWeight: 400, cursor: 'pointer'}}>
                    AGREEMENT
                </div>
                <div onClick={goToPolicy} style={{padding: "10px 15px", fontSize: 13, fontWeight: 500, cursor: 'pointer'}}>
                    PRIVACY POLICY
                </div>
                <div onClick={goToContact} style={{padding: "10px 15px", fontSize: 13, fontWeight: 400, cursor: 'pointer'}}>
                    CONTACT
                </div>
            </div>
            <div style={{display: "flex", justifyContent: "center", marginBottom: 32}}>
                <img onClick={goToInstagram} src={instagram} style={{width: 17, height: 17, cursor: "pointer"}} />
            </div>
            <div
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',         // ✅ 자동 줄바꿈
                    gap: '32px',              // 간격 유지
                    rowGap: '16px',            // 줄 간격
                    justifyContent: "center",
                    fontSize: 11,
                    marginBottom: 32,
                }}
                >
                <div>회사명: (주)하우스픽스</div>
                <div>대표자: kim min jeong</div>
                <div>주소 : 경북 영주시 대학로 77 (경북전문대학교) 148아트스퀘어 2층 6호</div>
                <div>이메일 : housefix@kakao.com</div>
                <div>전화 : 010-3091-9095</div>
                <div>팩스 : 0508-956-9095</div>
                <div>사업자등록번호 : 304-18-19347</div>
                <div>통신판매업신고 : 0000-0000</div>
            </div>
            <div style={{display: "flex", gap: 64, marginBottom: 32,}}>
                <div style={{fontSize: 12}}>COPYRIGHT (c) (주)하우스픽스 ALL RIGHTS RESERVED.</div>
            </div>
        </div>
    )
}

export default Footer;